module.exports = __webpack_public_path__ + "static/media/center.3355abb8.png";